import { Input } from 'antd';
import { StyledSearchInput } from './SearchInput.styled';

export default function SearchInput({
  inputRef,
  value,
  onChange,
  allowClear,
  placeholder,
}) {
  return (
    <StyledSearchInput>
      <Input.Search
        className="input"
        ref={inputRef}
        value={value}
        onChange={onChange}
        allowClear={allowClear}
        placeholder={placeholder}
      />
    </StyledSearchInput>
  );
}
